import React, { SyntheticEvent, useEffect, useState } from "react";
import {  Table, Header, DropdownProps } from "semantic-ui-react";
import agent from "../../app/api/agent";
import { _DrawType3DOptionsWithAll, _DrawTypeOptions, _StatusOptions } from "../../app/lib/CommonData";
import Draw3DLink from "../../app/lib/draw3dlink";
import LoadingComponent from "../../app/lib/LoadingComponent";
import MyDropDown from "../../app/lib/MyDropDown";
import MyTableWithSort from "../../app/lib/MyTableWithSort";
import NumberStatus from "../../app/lib/NumberStatus";
import { ForecastSystem3D } from "../../app/models/IDayResult";


export default function WinningBoxSystem3DDialog(){
    const [data, setData] = useState<ForecastSystem3D[]>([]);
    const [drawType, setDrawType] = useState("ABCD");
    const [status, setStatus] = useState("12");
    const [column, setColumn] = useState("Strike_Top3");
    const [direction, setDirection] = useState<"ascending" | "descending" | undefined>("descending");
    const [drawType3D, setDrawType3D] = useState("A");
    const [isLoading, setIsLoading] = useState(true);

    const handleColumnClick = (columnName : string)=>{
        if (column !== columnName){
          setDirection("ascending");
        }
        else{
          if (direction === undefined){
            setDirection('ascending');
          }
          else{
            setDirection(direction === "ascending" ? "descending" : "ascending");
          }
        }
        setColumn(columnName);
        setIsLoading(true);
      }
  
      const handleDropDownSelect3D = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
          setDrawType3D(option.value + "");
          setIsLoading(true);
    }

    const handleDropDownSelect = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
        setDrawType(option.value + "");
        setIsLoading(true);
   }

   const handleStatusSelect = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
       setStatus(option.value + "");
       setIsLoading(true);
    }
    useEffect(()=>{
        const selectedDate = localStorage.getItem("SelectedDate");
        const eWinBox = localStorage.getItem("BoxNo");

        var tempDirection = "";
        
        if (tempDirection !== undefined){
            tempDirection = direction === "ascending" ? "asc" : "desc";
        }



        agent.Draw4DResult.getWinningBox3D(selectedDate!, drawType, status, column, tempDirection, drawType3D, eWinBox + "").then((response)=>{
            setData(response);
            setIsLoading(false);
        }).catch(err=>setIsLoading(false));

        
    },[status, drawType, column, direction, drawType3D]);

    if (isLoading) {
        return <LoadingComponent content="Loading data. Please wait ..." ></LoadingComponent>
    }

    return (
        <div style={{overflow:"auto"}}>
        <Table unstackable celled sortable>

            <Table.Header>
                <Table.Row key="headerCondition">
                    <Table.Cell textAlign="center" colSpan="3">
                        <MyDropDown zIndex="20" placeholder='Select Forecast Draw Type' toolTip="Select Forecast Draw Type" toolTipDirection="top center" 
                            onChange={handleDropDownSelect} options={_DrawTypeOptions} defaultValue={drawType}>
                        </MyDropDown>
                    </Table.Cell>
                    <Table.Cell textAlign="center" colSpan="3">
                        <MyDropDown zIndex="21" placeholder='Select 3D Type' toolTip="Select 3D Type" toolTipDirection="top center" 
                            onChange={handleDropDownSelect3D} options={_DrawType3DOptionsWithAll} defaultValue={drawType3D}>
                        </MyDropDown>
                    </Table.Cell>

                    <Table.Cell textAlign="center" colSpan="4">
                        <MyDropDown zIndex="20" placeholder='Select Status' toolTip="Select Status" toolTipDirection="top center" 
                            onChange={handleStatusSelect} options={_StatusOptions} defaultValue={status}>
                        </MyDropDown>
                    </Table.Cell>
                </Table.Row>
                <Table.Row key="header">
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="System_3D" handleClick={handleColumnClick}>
                        System 3D
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Strike" handleClick={handleColumnClick}>
                        Hit All
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Strike_Top3" handleClick={handleColumnClick}>
                        Hit Top3
                    </MyTableWithSort> 

                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="System_Status" handleClick={handleColumnClick}>
                        System Status
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Top3_Status" handleClick={handleColumnClick}>
                        Top3 Status
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="System_Interval" handleClick={handleColumnClick}>
                        System Interval
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Top3_Interval" handleClick={handleColumnClick}>
                        Top3 Interval
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Rank_All" handleClick={handleColumnClick}>
                        All Rank
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Rank_Top3" handleClick={handleColumnClick}>
                        Top3 Rank 
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Month_Rank_All" handleClick={handleColumnClick}>
                    All Rank Monthly
                    </MyTableWithSort> 
                    <MyTableWithSort  textAlign="center" direction={direction} column={column} columnName="Month_Rank_Top3" handleClick={handleColumnClick}>
                    Top3 Rank Monthly
                    </MyTableWithSort> 

                    <Table.Cell textAlign="center"><Header as="h4">Forecast 4D</Header></Table.Cell>

                </Table.Row>
            </Table.Header>
            <Table.Body>
            {   data && data.length > 0 &&
                data.map((x,i)=>{
                return (
                    <Table.Row key={i}>
                        <Table.Cell textAlign="center">
                            <Draw3DLink title="" number={x.system_3D}>

                            </Draw3DLink>
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.strike}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.strike_Top3}
                        </Table.Cell>                        
                        <Table.Cell textAlign="center">
                            <NumberStatus status = {x.system_Status} />
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            <NumberStatus status = {x.top3_Status} />
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.system_Interval}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.top3_Interval}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.rank_All}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.rank_Top3}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.month_Rank_All}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.month_Rank_Top3}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {x.forecast_System4D}
                        </Table.Cell>

                    </Table.Row>
                )})
            }
            </Table.Body>
        </Table>
        </div>
    );
}